/**
 * FullStory Service
 * Handles all FullStory session tracking and data collection
 */ let sessionDataCache = null;
let cacheTimestamp = 0;
const CACHE_DURATION = 30000; // 30 seconds
/**
 * Get FullStory session data for BigBrain events
 * @returns {Object} FullStory session data
 */ export const getFullStoryData = ()=>{
    if (typeof window === 'undefined') {
        return {};
    }
    // Return cached data if it's still fresh
    const now = Date.now();
    if (sessionDataCache && now - cacheTimestamp < CACHE_DURATION) {
        return sessionDataCache;
    }
    const sessionData = {};
    // Get session URL if available
    if (window.FSSessionUrl) {
        sessionData.fs_session_url = window.FSSessionUrl;
    }
    // Get session start timestamp if available
    if (window.FSSessionStartedAt) {
        sessionData.fs_session_started_at = window.FSSessionStartedAt;
    }
    // Cache the result
    sessionDataCache = sessionData;
    cacheTimestamp = now;
    return sessionData;
};
